<template>
  <div class="skeleton-list-icon">
    <v-skeleton-loader
      :loading="loading"
      :max-width="maxWidth"
      type="list-item, list-item-avatar-two-line, image">
      <slot />
    </v-skeleton-loader>
  </div>
</template>

<script>
export default {
  name: 'SkeletonListIcon',
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    maxWidth: {
      type: String,
      default: "700"
    }
  }
}
</script>

<style lang="scss">
.skeleton-list-icon {
  .v-skeleton-loader__image {
    height: 80px;
  }
}
</style>
